class MovieEvent {
  constructor(el, opt) {
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {
    const modalTrigger = document.querySelector(".r-content__movie");
    const modalContent = document.querySelector(".movieModal");
    const overlay = document.querySelector(".movieModal-overlay");
    const modalClose = document.querySelector(".movieModal__close");

    modalTrigger.addEventListener("click", () => {
      modalTrigger.classList.add("is-active")
      overlay.classList.add("is-active")
      modalContent.classList.add("is-active")
    })

    overlay.addEventListener("click", () => {
      modalTrigger.classList.remove("is-active")
      overlay.classList.remove("is-active")
      modalContent.classList.remove("is-active")
    })

    modalClose.addEventListener("click", () => {
      modalTrigger.classList.remove("is-active")
      overlay.classList.remove("is-active")
      modalContent.classList.remove("is-active")
    })
  }
}